/**
 * The shared client-logo registry — the single source of truth for the brands
 * whose productions Ballee's dancers work with. Consumed by BOTH the agency
 * trust wall (`app/(agency)/_components/trust-section.tsx`) and the Flow
 * platform proof block (`components/marketing/client-logo-wall.tsx`), so the
 * list is never duplicated across surfaces (Critical Rule #8 — one edit surface
 * per entity).
 *
 * Order is Fever-first: Fever is Flow's reference production customer, so it
 * leads the wall on the Flow B2B landing. The agency wall renders the same set.
 */
export interface ClientLogo {
  name: string;
  src: string;
}

export const CLIENT_LOGOS: ClientLogo[] = [
  { name: 'Fever', src: '/agency/logos/fever.svg' },
  { name: 'Netflix', src: '/agency/logos/netflix.png' },
  { name: 'Prime Video', src: '/agency/logos/prime_video.svg' },
  { name: 'Chaumet', src: '/agency/logos/chaumet.svg' },
  { name: 'Repetto', src: '/agency/logos/repetto.svg' },
  { name: 'Yumiko', src: '/agency/logos/yumiko.svg' },
  { name: 'Frank Sorbier', src: '/agency/logos/frank_sorbier.svg' },
  { name: 'MAC', src: '/agency/logos/mac.svg' },
  { name: 'Collistar', src: '/agency/logos/collistar.svg' },
  { name: 'Coccinelle', src: '/agency/logos/coccinelle.png' },
  { name: 'Gemmyo', src: '/agency/logos/gemmyo.png' },
  { name: 'Chloé', src: '/agency/logos/chloe.svg' },
  { name: 'Longchamp', src: '/agency/logos/longchamp.png' },
  { name: "DellaLo' Milano", src: '/agency/logos/dellalo.png' },
  { name: 'Venchi 1878', src: '/agency/logos/venchi.png' },
  { name: 'Degas', src: '/agency/logos/degas.png' },
];
